import React from "react"
import './ProfilePosts.css'
import Post from "../Post"

function ProfilePosts(){
    return(
        <>
            <Post name='user' />
        </>
    )
}

export default ProfilePosts